/* tslint:disable */
/* eslint-disable */
/**
 * BrightSide Rest API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * Contact: support@bookonthebrightside.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { Message } from '../models';
// @ts-ignore
import type { MessageThread } from '../models';
// @ts-ignore
import type { NewThreadRequest } from '../models';
// @ts-ignore
import type { SendOptionsResponse } from '../models';
// @ts-ignore
import type { ThreadDetailsResponse } from '../models';
// @ts-ignore
import type { ThreadList } from '../models';
/**
 * ThreadsApi - axios parameter creator
 * @export
 */
export const ThreadsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Archives a specific thread, marking it as archived and removing it from the active inbox view.
         * @summary Archive a thread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveThread: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('archiveThread', 'id', id)
            const localVarPath = `/threads/{id}/archive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Create or load a message thread
         * @param {NewThreadRequest} newThreadRequest New thread request with phone or reservation number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewThread: async (newThreadRequest: NewThreadRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'newThreadRequest' is not null or undefined
            assertParamExists('createNewThread', 'newThreadRequest', newThreadRequest)
            const localVarPath = `/threads/new`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(newThreadRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a map of thread IDs to arrays of new messages after the given message IDs
         * @summary Get new messages for multiple threads after specific message IDs
         * @param {string} threadIds Comma-separated list of thread IDs
         * @param {string} lastMessageIds Comma-separated list of last known message IDs, corresponding to threadIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewMessages: async (threadIds: string, lastMessageIds: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'threadIds' is not null or undefined
            assertParamExists('getNewMessages', 'threadIds', threadIds)
            // verify required parameter 'lastMessageIds' is not null or undefined
            assertParamExists('getNewMessages', 'lastMessageIds', lastMessageIds)
            const localVarPath = `/threads/messages/after`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (threadIds !== undefined) {
                localVarQueryParameter['threadIds'] = threadIds;
            }

            if (lastMessageIds !== undefined) {
                localVarQueryParameter['lastMessageIds'] = lastMessageIds;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get send options for a reservation
         * @param {number} reservationNumber Reservation number to lookup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSendOptions: async (reservationNumber: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reservationNumber' is not null or undefined
            assertParamExists('getSendOptions', 'reservationNumber', reservationNumber)
            const localVarPath = `/threads/send-options`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (reservationNumber !== undefined) {
                localVarQueryParameter['reservationNumber'] = reservationNumber;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns all messages for a specific thread
         * @summary Get messages in a thread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThread: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getThread', 'id', id)
            const localVarPath = `/threads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Retrieves reservation, guest, and related thread information for the details pane of a specific message thread, identified by its ID.
         * @summary Get details for thread details pane
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadDetails: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getThreadDetails', 'id', id)
            const localVarPath = `/threads/{id}/details`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns a paginated list of threads with optional search filtering
         * @summary Get list of threads
         * @param {number} [offset] offset
         * @param {number} [size] Number of items per page
         * @param {string} [search] search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadList: async (offset?: number, size?: number, search?: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/threads`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (offset !== undefined) {
                localVarQueryParameter['offset'] = offset;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (search !== undefined) {
                localVarQueryParameter['search'] = search;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Mark a message as read
         * @param {number} id Thread ID
         * @param {number} messageId Message ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markMessageAsRead: async (id: number, messageId: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markMessageAsRead', 'id', id)
            // verify required parameter 'messageId' is not null or undefined
            assertParamExists('markMessageAsRead', 'messageId', messageId)
            const localVarPath = `/threads/{id}/messages/{messageId}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)))
                .replace(`{${"messageId"}}`, encodeURIComponent(String(messageId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks a specific thread as read.
         * @summary Mark a thread as read
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsRead: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markThreadAsRead', 'id', id)
            const localVarPath = `/threads/{id}/read`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Marks a specific thread as unread.
         * @summary Mark a thread as unread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsUnread: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('markThreadAsUnread', 'id', id)
            const localVarPath = `/threads/{id}/unread`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Posts a new message to the specified thread
         * @summary Send a message in a thread
         * @param {number} id Thread ID
         * @param {Message} message Message to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage: async (id: number, message: Message, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('sendMessage', 'id', id)
            // verify required parameter 'message' is not null or undefined
            assertParamExists('sendMessage', 'message', message)
            const localVarPath = `/threads/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(message, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Simulates receiving a new message with the specified content in the given thread for testing purposes
         * @summary Simulate receiving a new message in a thread
         * @param {number} id Thread ID
         * @param {string} body Simulated incoming message content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateReceivedMessage: async (id: number, body: string, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('simulateReceivedMessage', 'id', id)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('simulateReceivedMessage', 'body', body)
            const localVarPath = `/threads/{id}/simulate-message`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Unarchives a specific thread, restoring it to the active inbox view.
         * @summary Unarchive a thread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveThread: async (id: number, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('unarchiveThread', 'id', id)
            const localVarPath = `/threads/{id}/unarchive`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication bearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ThreadsApi - functional programming interface
 * @export
 */
export const ThreadsApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ThreadsApiAxiosParamCreator(configuration)
    return {
        /**
         * Archives a specific thread, marking it as archived and removing it from the active inbox view.
         * @summary Archive a thread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async archiveThread(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.archiveThread(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.archiveThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Create or load a message thread
         * @param {NewThreadRequest} newThreadRequest New thread request with phone or reservation number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async createNewThread(newThreadRequest: NewThreadRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.createNewThread(newThreadRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.createNewThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a map of thread IDs to arrays of new messages after the given message IDs
         * @summary Get new messages for multiple threads after specific message IDs
         * @param {string} threadIds Comma-separated list of thread IDs
         * @param {string} lastMessageIds Comma-separated list of last known message IDs, corresponding to threadIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getNewMessages(threadIds: string, lastMessageIds: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Message>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getNewMessages(threadIds, lastMessageIds, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.getNewMessages']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Get send options for a reservation
         * @param {number} reservationNumber Reservation number to lookup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSendOptions(reservationNumber: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<SendOptionsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSendOptions(reservationNumber, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.getSendOptions']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns all messages for a specific thread
         * @summary Get messages in a thread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThread(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<MessageThread>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThread(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.getThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Retrieves reservation, guest, and related thread information for the details pane of a specific message thread, identified by its ID.
         * @summary Get details for thread details pane
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThreadDetails(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadDetailsResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThreadDetails(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.getThreadDetails']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Returns a paginated list of threads with optional search filtering
         * @summary Get list of threads
         * @param {number} [offset] offset
         * @param {number} [size] Number of items per page
         * @param {string} [search] search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getThreadList(offset?: number, size?: number, search?: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ThreadList>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getThreadList(offset, size, search, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.getThreadList']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * 
         * @summary Mark a message as read
         * @param {number} id Thread ID
         * @param {number} messageId Message ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markMessageAsRead(id: number, messageId: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markMessageAsRead(id, messageId, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.markMessageAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks a specific thread as read.
         * @summary Mark a thread as read
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markThreadAsRead(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markThreadAsRead(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.markThreadAsRead']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Marks a specific thread as unread.
         * @summary Mark a thread as unread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async markThreadAsUnread(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.markThreadAsUnread(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.markThreadAsUnread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Posts a new message to the specified thread
         * @summary Send a message in a thread
         * @param {number} id Thread ID
         * @param {Message} message Message to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async sendMessage(id: number, message: Message, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.sendMessage(id, message, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.sendMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Simulates receiving a new message with the specified content in the given thread for testing purposes
         * @summary Simulate receiving a new message in a thread
         * @param {number} id Thread ID
         * @param {string} body Simulated incoming message content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async simulateReceivedMessage(id: number, body: string, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<number>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.simulateReceivedMessage(id, body, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.simulateReceivedMessage']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
        /**
         * Unarchives a specific thread, restoring it to the active inbox view.
         * @summary Unarchive a thread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unarchiveThread(id: number, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unarchiveThread(id, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ThreadsApi.unarchiveThread']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ThreadsApi - factory interface
 * @export
 */
export const ThreadsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ThreadsApiFp(configuration)
    return {
        /**
         * Archives a specific thread, marking it as archived and removing it from the active inbox view.
         * @summary Archive a thread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        archiveThread(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.archiveThread(id, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Create or load a message thread
         * @param {NewThreadRequest} newThreadRequest New thread request with phone or reservation number
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createNewThread(newThreadRequest: NewThreadRequest, options?: RawAxiosRequestConfig): AxiosPromise<MessageThread> {
            return localVarFp.createNewThread(newThreadRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a map of thread IDs to arrays of new messages after the given message IDs
         * @summary Get new messages for multiple threads after specific message IDs
         * @param {string} threadIds Comma-separated list of thread IDs
         * @param {string} lastMessageIds Comma-separated list of last known message IDs, corresponding to threadIds
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getNewMessages(threadIds: string, lastMessageIds: string, options?: RawAxiosRequestConfig): AxiosPromise<Array<Message>> {
            return localVarFp.getNewMessages(threadIds, lastMessageIds, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get send options for a reservation
         * @param {number} reservationNumber Reservation number to lookup
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSendOptions(reservationNumber: number, options?: RawAxiosRequestConfig): AxiosPromise<SendOptionsResponse> {
            return localVarFp.getSendOptions(reservationNumber, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns all messages for a specific thread
         * @summary Get messages in a thread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThread(id: number, options?: RawAxiosRequestConfig): AxiosPromise<MessageThread> {
            return localVarFp.getThread(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Retrieves reservation, guest, and related thread information for the details pane of a specific message thread, identified by its ID.
         * @summary Get details for thread details pane
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadDetails(id: number, options?: RawAxiosRequestConfig): AxiosPromise<ThreadDetailsResponse> {
            return localVarFp.getThreadDetails(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns a paginated list of threads with optional search filtering
         * @summary Get list of threads
         * @param {number} [offset] offset
         * @param {number} [size] Number of items per page
         * @param {string} [search] search
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getThreadList(offset?: number, size?: number, search?: string, options?: RawAxiosRequestConfig): AxiosPromise<ThreadList> {
            return localVarFp.getThreadList(offset, size, search, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Mark a message as read
         * @param {number} id Thread ID
         * @param {number} messageId Message ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markMessageAsRead(id: number, messageId: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markMessageAsRead(id, messageId, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks a specific thread as read.
         * @summary Mark a thread as read
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsRead(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markThreadAsRead(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Marks a specific thread as unread.
         * @summary Mark a thread as unread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        markThreadAsUnread(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.markThreadAsUnread(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Posts a new message to the specified thread
         * @summary Send a message in a thread
         * @param {number} id Thread ID
         * @param {Message} message Message to send
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendMessage(id: number, message: Message, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.sendMessage(id, message, options).then((request) => request(axios, basePath));
        },
        /**
         * Simulates receiving a new message with the specified content in the given thread for testing purposes
         * @summary Simulate receiving a new message in a thread
         * @param {number} id Thread ID
         * @param {string} body Simulated incoming message content
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        simulateReceivedMessage(id: number, body: string, options?: RawAxiosRequestConfig): AxiosPromise<number> {
            return localVarFp.simulateReceivedMessage(id, body, options).then((request) => request(axios, basePath));
        },
        /**
         * Unarchives a specific thread, restoring it to the active inbox view.
         * @summary Unarchive a thread
         * @param {number} id Thread ID
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unarchiveThread(id: number, options?: RawAxiosRequestConfig): AxiosPromise<void> {
            return localVarFp.unarchiveThread(id, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ThreadsApi - object-oriented interface
 * @export
 * @class ThreadsApi
 * @extends {BaseAPI}
 */
export class ThreadsApi extends BaseAPI {
    /**
     * Archives a specific thread, marking it as archived and removing it from the active inbox view.
     * @summary Archive a thread
     * @param {number} id Thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public archiveThread(id: number, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).archiveThread(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Create or load a message thread
     * @param {NewThreadRequest} newThreadRequest New thread request with phone or reservation number
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public createNewThread(newThreadRequest: NewThreadRequest, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).createNewThread(newThreadRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a map of thread IDs to arrays of new messages after the given message IDs
     * @summary Get new messages for multiple threads after specific message IDs
     * @param {string} threadIds Comma-separated list of thread IDs
     * @param {string} lastMessageIds Comma-separated list of last known message IDs, corresponding to threadIds
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public getNewMessages(threadIds: string, lastMessageIds: string, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).getNewMessages(threadIds, lastMessageIds, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get send options for a reservation
     * @param {number} reservationNumber Reservation number to lookup
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public getSendOptions(reservationNumber: number, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).getSendOptions(reservationNumber, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns all messages for a specific thread
     * @summary Get messages in a thread
     * @param {number} id Thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public getThread(id: number, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).getThread(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Retrieves reservation, guest, and related thread information for the details pane of a specific message thread, identified by its ID.
     * @summary Get details for thread details pane
     * @param {number} id Thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public getThreadDetails(id: number, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).getThreadDetails(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns a paginated list of threads with optional search filtering
     * @summary Get list of threads
     * @param {number} [offset] offset
     * @param {number} [size] Number of items per page
     * @param {string} [search] search
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public getThreadList(offset?: number, size?: number, search?: string, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).getThreadList(offset, size, search, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Mark a message as read
     * @param {number} id Thread ID
     * @param {number} messageId Message ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public markMessageAsRead(id: number, messageId: number, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).markMessageAsRead(id, messageId, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks a specific thread as read.
     * @summary Mark a thread as read
     * @param {number} id Thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public markThreadAsRead(id: number, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).markThreadAsRead(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Marks a specific thread as unread.
     * @summary Mark a thread as unread
     * @param {number} id Thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public markThreadAsUnread(id: number, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).markThreadAsUnread(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Posts a new message to the specified thread
     * @summary Send a message in a thread
     * @param {number} id Thread ID
     * @param {Message} message Message to send
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public sendMessage(id: number, message: Message, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).sendMessage(id, message, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Simulates receiving a new message with the specified content in the given thread for testing purposes
     * @summary Simulate receiving a new message in a thread
     * @param {number} id Thread ID
     * @param {string} body Simulated incoming message content
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public simulateReceivedMessage(id: number, body: string, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).simulateReceivedMessage(id, body, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Unarchives a specific thread, restoring it to the active inbox view.
     * @summary Unarchive a thread
     * @param {number} id Thread ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ThreadsApi
     */
    public unarchiveThread(id: number, options?: RawAxiosRequestConfig) {
        return ThreadsApiFp(this.configuration).unarchiveThread(id, options).then((request) => request(this.axios, this.basePath));
    }
}

